import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";

const ScrollDownArrow: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const scrollableHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      const scrolled = window.scrollY;

      // Hide the button if the user has scrolled to the bottom
      setIsVisible(scrolled < scrollableHeight);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToNextSection = () => {
    window.scrollBy({
      top: window.innerHeight,
      behavior: "smooth",
    });
  };

  return (
    isVisible && (
      <button
        onClick={scrollToNextSection}
        className="fixed bottom-24 lg:bottom-4 left-1/2 transform -translate-x-1/2 bg-amber-200 hover:bg-amber-500 text-white p-3 rounded-full shadow-lg transition-all opacity-40 hover:opacity-60 z-50"
        aria-label="Scroll down"
      >
        <ChevronDown className="h-6 w-6" />
      </button>
    )
  );
};

export default ScrollDownArrow;